<template>
  <v-card>
    <div class="pa-4">
      <div class="d-flex justify-space-between align-center">
        <h3 class="text">Thông tin cơ bản</h3>
        <v-btn
          outlined
          color="#0D47A1"
          @click="() => $refs['edit-popup'].openDialog(event)"
          v-if="$auth.policies['update-event']"
        >
          Sửa
        </v-btn>
      </div>
      <div class="mt-2">
        <div class="d-flex" v-if="event.thumbnail">
          <div class="text title-info">Ảnh đại diện</div>
          <img :src="event.thumbnail" style="width: 200px;" class="mb-2" />
        </div>
        <div class="d-flex">
          <div class="text title-info">Tiêu đề</div>
          <div class="text">{{ event.title }}</div>
        </div>
        <div class="d-flex mt-4">
          <div class="text title-info">Mô tả</div>
          <div class="text">
            {{ event.description }}
          </div>
        </div>
        <div class="d-flex mt-4">
          <div class="text title-info">Ngày diễn ra</div>
          <div class="text">{{ event.from | ddmmyyyy }} - {{ event.to | ddmmyyyy }}</div>
        </div>
        <div class="d-flex mt-4">
          <div class="text title-info">Trạng thái hiển thị</div>
          <div class="text">
            <v-chip :color="event.isPublished | eventStatusColor" small class="white--text">
              {{ event.isPublished | isPublishedText }}
            </v-chip>
          </div>
        </div>
        <div class="d-flex mt-4">
          <div class="text title-info">Trạng thái đăng ký</div>
          <div class="text">
            <v-chip :color="event.isOpenRegistration | eventStatusColor" small class="white--text">
              {{ event.isOpenRegistration | isOpenRegistrationText }}
            </v-chip>
          </div>
        </div>
        <div class="d-flex mt-4" v-if="event.registrationDeadline">
          <div class="text title-info">Trạng thái hết hạn</div>
          <div class="text">
            <v-chip :color="event.isExpired | eventExpiredColor" small class="white--text">
              {{ event.isExpired | eventIsExpiredText }}
            </v-chip>
          </div>
        </div>
        <div class="d-flex mt-4" v-if="event.registrationDeadline">
          <div class="text title-info">Hạn đăng ký</div>
          <div class="d-flex flex-column">
            <div class="text">{{ event.registrationDeadline | ddmmyyyy }}</div>
            <div class="grey--text">Khi quá hạn đăng ký, trạng thái đăng ký sẽ tự động chuyển thành "Đóng đăng ký"</div>
          </div>
        </div>
        <div class="d-flex mt-4">
          <div class="text title-info">Áp dụng cho</div>
          <div class="text">
            {{ event.appliedType | appliedTypeText }} {{ event.appliedForGrades | appliedForGradesTitle }}
          </div>
        </div>
      </div>
    </div>
    <EventEditDialog ref="edit-popup" />
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex'
import EventEditDialog from './EventEditDialog.vue'
import helpers from '../helpers.js'

export default {
  components: { EventEditDialog },
  computed: {
    ...mapGetters({
      event: 'events/getItem'
    })
  },
  filters: {
    isOpenRegistrationText(val) {
      return val ? 'Đang mở' : 'Đã đóng'
    },
    eventStatusColor(val) {
      return val ? 'green' : 'grey'
    },
    isPublishedText(val) {
      return val ? 'Xuất bản' : 'Chưa xuất bản'
    },
    eventExpiredColor(val) {
      return val ? 'red' : 'green'
    },
    eventIsExpiredText(val) {
      return val ? 'Hết hạn' : 'Còn hạn'
    },
    appliedTypeText(val) {
      return helpers.APPLIED_TYPE[val]
    },
    appliedForGradesTitle(val) {
      if (Array.isArray(val) && val.length) {
        return `(${val.map(x => x.title).join(', ')})`
      }
      return ''
    }
  }
}
</script>
<style lang="scss" scoped>
.title-info {
  min-width: 170px;
}
</style>
